import { observer } from 'mobx-react-lite'
import { PresetList, PresetListItem } from 'shared/Preset'
import { uiStore } from 'shared/store/uiStore'
import { ChatbotInstructionType } from 'entities/Chatbot'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ChatbotTemplateList } from 'pages/chatbot/config'
import { ChatbotPath } from 'pages/chatbot/route/chatbotPath'
import { ChatbotRoutes } from 'pages/chatbot'
import type { CreateChatbotStore } from 'pages/chatbot/store/chatbotCreateStore'
import styles from './styles.module.scss'

export const TextingContent = observer(({ store }: { store: CreateChatbotStore }) => {
  const { instructions, chatbot, onClose } = store

  const { featureFlagsStore } = useEntitiesContext()
  const handleChangeType = (type: ChatbotInstructionType) => {
    const instruction = instructions.get(type)
    if (!!instruction) chatbot.settings.setInstruction(instruction)

    chatbot.setType(type)
  }

  const onNext = () => {
    onClose()
    const payload = chatbot.toJSON()
    if (!payload) return
    const path =
      payload?.type === ChatbotInstructionType.BookAppointment
        ? `/${ChatbotPath.newBookAppointment}`
        : `/${ChatbotRoutes.root}/${ChatbotRoutes.new}`

    uiStore.changeRoute({
      path,
      options: {
        state: payload,
      },
    })
  }
  return (
    <>
      <PresetList className={styles.presetList}>
        {ChatbotTemplateList.filter((template) => {
          if (!featureFlagsStore.salesmsg_ai_agent_book_appointment_v2) {
            return template.type !== ChatbotInstructionType.BookAppointment
          }
          return true
        }).map((template) => (
          <PresetListItem
            key={template.name}
            onClick={() => {
              handleChangeType(template.type)
              onNext()
            }}
            icon={template.icon}
            name={template.name}
            description={template.description}
            isNew={template.isNew}
          />
        ))}
      </PresetList>
    </>
  )
})
